import { create } from 'zustand';

import { TieBreakerLineupVisibility } from '@/entities/season-division/SeasonDivisionPool';

interface TiebreakerStore {
	tiebreakerRef: HTMLDivElement | null;
	setTiebreakerRef: (ref: HTMLDivElement | null) => void;
	scrollToTiebreaker: () => void;
	tieBreakerLineupVisibility: TieBreakerLineupVisibility;
	setTieBreakerLineupVisibility: (tieBreakerLineupOption: TieBreakerLineupVisibility) => void;
}

export const useTiebreakerStore = create<TiebreakerStore>((set, get) => ({
	tiebreakerRef: null,
	setTiebreakerRef: (ref) => set({ tiebreakerRef: ref }),
	scrollToTiebreaker: () => {
		const ref = get().tiebreakerRef;
		ref?.scrollIntoView({ behavior: 'smooth' });
	},
	tieBreakerLineupVisibility: TieBreakerLineupVisibility.TIE_BREAKER_LINEUP_OPTION_AS_SOON_AS_LINEUPS_CREATED,
	setTieBreakerLineupVisibility: (tieBreakerLineupVisibility: TieBreakerLineupVisibility) => set({ tieBreakerLineupVisibility })
}));
